import vSessionTimeout from "./v-session-timeout.vue";

export default Vue => {
  Vue.component("v-session-timeout", vSessionTimeout);
};
